import { MessagePlugin } from 'tdesign-react';
import { MESSAGE_DURATION, DEFAULT_MESSAGES, REGEX } from '../const/constants.js';

/**
 * 复制文字内容到剪切板
 * @param {string} text - 要复制的文本
 */
export const copyText = function (text) {
  const fallbackCopyToClipboard = (text) => {
    var textarea = document.createElement('textarea');
    document.body.appendChild(textarea);
    textarea.style.position = 'fixed';
    textarea.style.clip = 'rect(0 0 0 0)';
    textarea.style.top = '10px';
    textarea.value = text;
    textarea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        MessagePlugin.success({
          content: DEFAULT_MESSAGES.COPY_SUCCESS,
          duration: MESSAGE_DURATION
        });
      } else {
        console.error('降级方案复制失败');
      }
    } catch (err) {
      console.error('降级方案复制出错:', err);
    } finally {
      document.body.removeChild(textarea);
    }
  };
  try {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(res => {
        MessagePlugin.success({
          content: DEFAULT_MESSAGES.COPY_SUCCESS,
          duration: MESSAGE_DURATION
        });
      })
        .catch(err => {
          console.error('现代API复制失败，使用降级方案:', err);
          fallbackCopyToClipboard(text);
        });
    } else {
      fallbackCopyToClipboard(text);
    }
  } catch (err) {
    console.error('复制失败:', err);
  }
};

/**
 * 获取 URL 参数
 * @param {string} name - 参数名
 * @returns {string|null} 参数值
 */
export function getQueryString(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substring(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}

/**
 * 按中英文逗号分割字符串
 * @param {string} str - 要分割的字符串
 * @param {Object} options - 配置选项
 * @param {boolean} options.trim - 是否清除前后空格，默认 true
 * @param {boolean} options.removeEmpty - 是否移除空值，默认 true
 * @returns {Array} 分割后的数组
 */
export const splitByCommas = (str, options = {}) => {
  const {
    trim = true,
    removeEmpty = true
  } = options;

  return str.split(REGEX.COMMA)
    .map(item => trim ? item.trim() : item)
    .filter(item => !removeEmpty || item);
};
